<h1 class="modal-header">{{ statement?.defaultDescription }}</h1>
<p class="my-5">
	Enter the default description below that will be applied to the statement of
	account documents by default. This text can be overridden within the matter if
	needed.
</p>
<div>
	<app-html-editor
		[debounceTime]="0"
		[document]="data?.statement?.documentHtmlText"
		(onChange)="setDocumentHtmlText($event)"
		minHeight="400px"
	></app-html-editor>
</div>
<div class="flex items-center justify-between mt-5">
	<app-button (click)="cancel()" btn="tertiary">Cancel</app-button>
	<app-button (click)="save()">Save</app-button>
</div>
